import type { Hue } from "./types"

/** The web app's eight identity hues, which an Area or a Label is drawn in one of. */
export const hues: readonly Hue[] = [1, 2, 3, 4, 5, 6, 7, 8]

/**
 * Each hue by the name a picker gives it, for a screen reader, a tooltip, and a connected agent
 * naming a colour: the words say which swatch it is, never what it means.
 */
export const hueNames: Record<Hue, string> = {
  1: "Red",
  2: "Orange",
  3: "Olive",
  4: "Green",
  5: "Teal",
  6: "Blue",
  7: "Violet",
  8: "Pink",
}

/** Whether a number arriving in a request is one of the eight hues. */
export const isHue = (value: number): value is Hue => hues.includes(value as Hue)

/**
 * The hue fewest of `used` are, the lowest on a tie, so a new Area or Label stands apart while it
 * can.
 */
export function leastUsedHue(used: readonly Hue[]): Hue {
  const uses = (hue: Hue) => used.filter((each) => each === hue).length
  return hues.reduce((least, hue) => (uses(hue) < uses(least) ? hue : least))
}
